// extracted by mini-css-extract-plugin
export var builderWrapper = "landingPage-module--builderWrapper--VgyJl";
export var formContainer = "landingPage-module--formContainer--edVor";
export var landingFormWrapper = "landingPage-module--landingFormWrapper--LnbUd";
export var mainContentWrapper = "landingPage-module--mainContentWrapper--nDb24";